import { render, staticRenderFns } from "./SignComplete.vue?vue&type=template&id=6a3b9650&scoped=true"
import script from "./SignComplete.vue?vue&type=script&lang=js"
export * from "./SignComplete.vue?vue&type=script&lang=js"
import style0 from "./SignComplete.vue?vue&type=style&index=0&id=6a3b9650&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3b9650",
  null
  
)

export default component.exports